import { useSelector } from 'react-redux';
import Permission from './permission';
import Permissions from './permissions';
import UserLogin from './user-login';
import UserLogins from './user-logins';

function getPageForRoute(key: string) {

    const selected = {
        'logins': <UserLogins />,
        'permissions': < Permissions />,
        'login': < UserLogin />,
        'permission': <Permission />
    }[key];

    if (selected) { return selected; }
    return <div style={{ marginLeft: "20px", marginTop: "20px" }}>This page is not available yet</div>
}

function getKeyFromPath(path: string) {
    const contentKey = 3;
    const key = path.split('/')[contentKey];
    return key;
}

const UserIndex = () => {
    const page = useSelector((state: any) => state.router.location.pathname);

    return getPageForRoute(getKeyFromPath(page));
}

export default UserIndex;
